 import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup, FormArray, FormControl } from '@angular/forms';
import { StatusModalComponent } from '../../../../../modals/status-modal/status-modal.component';
import { Subject, Subscription } from 'rxjs';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { LoyaltyService } from '../../../../../../shared/_services/loyalty.service';
import { UtilService } from '../../../../../../shared/_services/util.service';
import { HotelManagementService } from '../../../../../../shared/_services/hotel-management.service';
import { GetJsonService } from '../../../../../../shared/_services/get-json.service';

@Component({
  selector: 'app-landing-page-catalog-banner',
  templateUrl: './landing-page-catalog-banner.component.html',
  styleUrls: ['./landing-page-catalog-banner.component.scss']
})
export class LandingPageCatalogBannerComponent implements OnInit {
  public reset: any[] = [{}];
  flagA: boolean = true;
  spanish: any;
  english: any;
  rulesListEs: any;
  rulesListEn: any;
  chosenLanguage: any = "en";
  isDirtyEn: boolean = false;
  isDirtyEs: boolean = false;
  statusModal: BsModalRef;
  loyaltyFormEs: FormGroup;
  loyaltyFormEn: FormGroup;
  errorDetails: any;
  successMsg: string;
  brand: any;
  selectedRules: any[] = [];
  private subscription: Subscription;
  private unsubscribe: Subject<void> = new Subject<void>();
  constructor(
    private fb: FormBuilder,
    public translate: TranslateService,
    private hotelManagementService: HotelManagementService,
    private loyaltyService: LoyaltyService,
    private utilService: UtilService,
    public modalService: BsModalService,
    private getJsonService: GetJsonService
  ) {
    let user = JSON.parse(localStorage.getItem('loggedInUser'));
    translate.setDefaultLang('en');
    translate.use('en');
    this.modalService.onHide
      .takeUntil(this.unsubscribe).subscribe(res => {
        if (this.statusModal) {
          if (this.statusModal.content.srcObject.type == "hca-wizard") {
            if (this.statusModal.content.srcObject.action == "action1") {
              // Resets the form data
            }
          }
          if (this.statusModal.content.srcObject.type == "hca-catalog-banner") {
            if (this.statusModal.content.srcObject.action == "action1") {
              if (this.isDirtyEn == true) {
                this.isDirtyEn = false;
                setTimeout(() => {
                  this.getCatalogBanner(this.brand.brandId);
                  let element = document.getElementById("es");
                  element.click();
                 
                }, 50);
              }
              if (this.isDirtyEs == true) {
                this.isDirtyEs = false;
                setTimeout(() => {
                  this.getCatalogBanner(this.brand.brandId);
                  let element = document.getElementById("en");
                  element.click();
                }, 50);
              }
            }
          }
        }
      })
  }

  saveForm() {
    console.log("this.loyaltyFormEn.value============", this.loyaltyFormEn.value);
    console.log("this.loyaltyFormEn.value============", this.loyaltyFormEs.value);
    this.hotelManagementService.getSelectedBrand()
    let formData = {
      brandId: this.hotelManagementService.getSelectedBrand().brandId,
      layouts: [this.loyaltyFormEn.value, this.loyaltyFormEs.value]
    }
    console.log(formData);
    this.loyaltyService.saveLoyaltyWebsite(formData).subscribe(res => {
      this.isDirtyEn = false;
      this.isDirtyEs = false;
      console.log(res);
      this.successMsg = 'Saved successfully';
      setTimeout(() => {
        this.successMsg = '';
      }, 1500);
    }, err => {
      console.error('Error Saving', err.message);
      setTimeout(() => {
        this.errorDetails = '';
      }, 1500);
    })
  }

  checkSelection(isChecked?: boolean, control?, type?, source?) {
    const formControl = <FormArray>this[control].controls['rules'];
    if (isChecked) {
      formControl.push(new FormControl(type.id));
      if (source == "fromHTML") {
        if (this.chosenLanguage == "en") {
          this.isDirtyEn = true;
        }
        else if (this.chosenLanguage == "es") {
          this.isDirtyEs = true;
        }
      }
    } else {
      let index = formControl.controls.findIndex(x => x.value == type.id);
      formControl.removeAt(index);
      if (source == "fromHTML") {
        if (this.chosenLanguage == "en") {
          this.isDirtyEn = true;
        }
        else if (this.chosenLanguage == "es") {
          this.isDirtyEs = true;
        }
      }
    }
  }

  getCatalogBanner(brandId) {
    this.initForm('en');
    this.initForm('es');
    this.loyaltyService.getCatalogBanner(brandId).subscribe(res => {
      console.log('=========== catalog banner data ========', res);
      if (res.error == 0) {
        if (res.responseObj && res.responseObj.length) {
          res.responseObj.forEach(data => {
            if (data.languageId == 1) {
              this.initForm('en', data);
              if(data.ruleTos && data.ruleTos.length) {
                data.ruleTos.forEach(rule => {
                  if (rule.languageId == 1) {
                    this.checkSelection(true, 'loyaltyFormEn', { id: rule.id });
                  }
                })
              }
            }
            if (data.languageId == 2) {
              this.initForm('es', data);
              if(data.ruleTos && data.ruleTos.length) {
                data.ruleTos.forEach(rule => {
                  if (rule.languageId == 2) {
                    this.checkSelection(true, 'loyaltyFormEs', { id: rule.id });
                  }
                })
              }
            }
          })
        }
      }
    }, err => {
      console.error('Error fetching loyalty catalog banner', err);
    })
  }

  getCatalogRules() {
    this.loyaltyService.getCatalogRules().subscribe(res => {
      console.log('=========== catalog rules ========', res);
      if (res.error == 0) {
        // this.rulesList = res.responseObj.rules;
        if (res.responseObj.rules) {
          this.rulesListEn = res.responseObj.rules.filter(data => data.languageId == 1);
          this.rulesListEs = res.responseObj.rules.filter(data => data.languageId == 2);
        }
        console.log(this.rulesListEn);
        console.log(this.rulesListEs);
      }
    }, err => {
      console.error('Error fetching loyalty website header and footer data', err);
    })
  }


  initForm(lang?, data?) {
    if (lang == 'en') {
      this.loyaltyFormEn = this.fb.group({
        languageId: [1],
        layoutId: [1],
        header: [data ? data.header : null],
        subheader: [data ? data.subheader : null],
        rules: this.fb.array([])
      })
      this.loyaltyFormEn.valueChanges.subscribe(data => {
        if (this.loyaltyFormEn.dirty) {
          this.isDirtyEn = true;
          console.log("en dirty " + this.isDirtyEn);
        }
        else {
          this.isDirtyEn = false;
        }
      });
    }
    if (lang == 'es') {
      this.loyaltyFormEs = this.fb.group({
        languageId: [2],
        layoutId: [1],
        header: [data ? data.header : null],
        subheader: [data ? data.subheader : null],
        rules: this.fb.array([])
      })
      this.loyaltyFormEs.valueChanges.subscribe(data => {
        if (this.loyaltyFormEs.dirty) {
          this.isDirtyEs = true;
          console.log("es dirty " + this.isDirtyEn);
        }
        else {
          this.isDirtyEs = false;
        }
      });
    }
  }

  changeLanguage(language) {
    this.chosenLanguage = language;
    if (this.isDirtyEn == true) {
      this.stayOnPage("english");
    }
    else if (this.isDirtyEs == true) {
      this.stayOnPage("spanish");
    }
  }

  stayOnPage(language) {
    let title = "";
    let status = "";
    let message = "";
    let action1 = "";
    let action2 = "";
    if (language == "english") {
      title = this.english.MODAL.CONFIRM;
      status = this.english.MODAL.ACTIVE;
      message = this.english.MODAL.NOT_SAVED;
      action1 = this.english.MODAL.YES;
      action2 = this.english.MODAL.NO;
    }
    else {
      title = this.spanish.MODAL.CONFIRM;
      status = this.spanish.MODAL.ACTIVE;
      message = this.spanish.MODAL.NOT_SAVED;
      action1 = this.spanish.MODAL.YES;
      action2 = this.spanish.MODAL.NO;
    }

    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    this.statusModal.content.srcObject = {
      mode: 'custom',
      type: 'hca-catalog-banner',
      title: title,
      status: status,
      message: message,
      action1: action1,
      action2: action2,
      action: '',
      style: 'active'
    }
  }
  getEnglishTranslations() {
    this.getJsonService.getJSON("../assets/i18n/", "en.json")
      .subscribe(
      (res) => {
        this.english = res;
        console.log("English Translations: " + res);
      },
      (err) => console.error("English Translations" + err));

  }
  getSpanishTranslations() {
    this.getJsonService.getJSON("../assets/i18n/", "es.json")
      .subscribe(
      (res) => {
        this.spanish = res;
        console.log("Spanish Translations: " + res);
      },
      (err) => console.error("Spanish Translations" + err));
  }
  ngOnInit() {
    this.getCatalogRules();
    this.subscription = this.loyaltyService.brandState
      .subscribe((state: any) => {
        this.brand = state.brand;
        this.getCatalogBanner(this.brand.brandId);
      });
    this.initForm('en');
    this.initForm('es');
    this.getEnglishTranslations();
    this.getSpanishTranslations();
  }

  ngAfterViewInit() {
    this.brand = this.hotelManagementService.getSelectedBrand();
    this.getCatalogBanner(this.brand ? this.brand.brandId : null);

  }

}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/settings/hca-loyalty-website/landing-page-catalog-banner/landing-page-catalog-banner.component.ts